import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { getByID } from '@adornis/baseql/operations/mongo.js';
import { DateTime } from 'luxon';
import { Participation } from './Participation.js';
import { Workshop } from './workshop.js';

@Entity()
export class AppointmentParticipation extends AdornisEntity {
  static override _class = 'AppointmentParticipation';

  @Field(type => String, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @Field(type => DateTime, { default: v => v ?? DateTime.now() })
  date!: DateTime;

  @Field(type => String)
  appointmentID!: string;
}

@Entity()
export class ParticipationWorkshop extends Participation<Workshop> {
  static override _class = 'ParticipationWorkshop';

  @Field(type => [AppointmentParticipation], { default: v => v ?? [] })
  appointmentParticipations: Maybe<AppointmentParticipation[]>;

  public override async timespan() {
    const product = await getByID(
      Workshop,
      this.productID,
    )({
      appointments: {
        start: 1,
        end: 1,
        isNonBlocking: 1,
        name: 1,
        location: 1,
        lastReminderMailSent: 1,
        meetingLink: { link: 1, ownerID: 1 },
      },
    });

    if (!product) throw new Error('product is missing: ' + this.productID);
    // if (!(product instanceof Workshop)) throw new Error('invalid product instance');

    return product.appointments;
  }
}
